<template>
  <div class="lobby-page">
    <header-nav />
    <loading :show="showLoader" />
    <v-container class="lobby-container">
      <v-row>
        <v-col cols="12" class="mt-8">
          <h1 class="lobby-description">
            Olá, <b>{{ username }}</b>! Bem vindo.
            <br>
            {{ greetMessage }}
          </h1>
        </v-col>
      </v-row>
      <v-row>
        <v-spacer />
        <v-col cols="12" md="10" xl="9">
          <v-alert type="error" prominent dismissible outlined text class="mt-4">
            O atendimento para <b>Cardiologia</b> está novamente disponível no nosso <b>canal de consultorias 0800</b>,
            exclusivo para casos inseridos no <b>Gercon</b>. Confira todas as especialidades disponíveis:
            <em>Cardiologia, Dermatologia, Endocrinologia, Gastroenterologia, Ginecologia e Obstetrícia, Hematologia,
            Infectologia, Nefrologia, Neurologia, Pneumologia, Reumatologia e Urologia.</em>
            <br><br>
            Para diagnósticos em <b>Dermatologia e Estomatologia</b>, utilize o perfil
            <b>Solicitante Diagnóstico</b>, sem necessidade de encaminhamento pelo Gercon.
          </v-alert>
        </v-col>
        <v-spacer />
      </v-row>
      <profile-card
        :roles="roles"
        @emitter-show-loader="showLoader = true" />
    </v-container>
  </div>
</template>

<script>
  import { decodeJwt } from '@/utils/decodeJwt';
  import { deleteToken } from '@/utils/cookies';
  import { getCookies } from '@/utils/cookies';

  import HeaderNav from '@/components/HeaderNav';
  import Loading from '@/components/Loading';
  import ProfileCard from '@/components/ProfileCard';

  export default {
    title: 'Lobby - TelessaúdeRS',
    name: 'LobbyPage',
    components: {
      'header-nav': HeaderNav,
      'loading': Loading,
      'profile-card': ProfileCard
    },
    data: () => ({
      roles: [],
      username: '',
      showLoader: false
    }),
    computed: {
      greetMessage() {
        return this.roles.length
          ? 'Selecione o serviço desejado'
          : 'Você não possui perfil selecionável.'
      },
    },
    created() {
      window.addEventListener("pageshow", (event) => {
        // NOTE: garante que o loader será escondido ao voltar
        // para a página através do botão de voltar do navegador (bfcache).
        if (event.persisted) this.showLoader = false;
      });

      const cookies = getCookies();
      const servicetoken = decodeJwt(cookies['servicetoken']);
      try {
        this.username = this.formatUsername(servicetoken.claims.username);
      } catch (e) {
        deleteToken();
        window.location.href = process.env.VUE_APP_URL_PLATA + '/accounts/logout/';
      }
      let rolesList = Object.keys(servicetoken.claims.roles).map(service => {
        // NOTE: usuário pode ter mais de um perfil igual no mesmo serviço em unidades diferentes
        return [...new Set(servicetoken.claims.roles[service])];
      }).flat();

      // NOTE: usuário pode ter mais de um perfil igual em serviços diferentes
      if (rolesList.length) this.roles = [...new Set(rolesList)];
    },
    methods: {
      formatUsername(username) {
        return username.split(' ').map((item) => {
          const title = item.toLowerCase();
          return title.charAt(0).toUpperCase() + title.slice(1);
        }).join(' ');
      },
    }
  }
</script>

<style scoped>
.lobby-page {
  min-height: 100vh;
  background-color: #F6F6F6;
}

.lobby-description {
  color: #00000099;
  font-family: 'Lato', sans-serif;
  font-size: 24px;
  font-weight: normal;
  text-align: center;
}
</style>
